import { Pet } from "../../core/pet";
import { Resistance, type AbnormalResistance } from "../../core/pet";
import { AbilityValue } from "../../core/abval";
import * as type from "../../core/type";
import * as skill from "../skill/迪符特";
import { Soulmark } from "../../core/soulmark";
import { Skin } from "../../core/skin";

export class 迪符特 extends Pet {
    /**
     *
     * @param ablis 能力值
     * @param resis 伤害抗性
     * @param abnormalResistance 异常抗性，默认无
     */
    constructor(ablis: AbilityValue, resis: Resistance, abnormalResistance: ReadonlyArray<Readonly<AbnormalResistance>> = []) {
        super(804, "迪符特", type.普通, ablis);
        this.抗性 = resis;
        this.异常抗性 = abnormalResistance;
        this.魂印 = new Soulmark([
            "1. 迪符特的攻击技能命中后有15%的几率秒杀对手，未触发则使对手2回合内无法使用属性技能。",
            "2. 迪符特的属性技能命中后有50%的几率令对手防御、特防等级-1，未触发则免疫下1次异常状态；若对手不处于能力下降状态，则吸取对手最大体力的1/3。",
            "3. 迪符特的物理技能命中后有50%的几率使对手3回合内无法通过技能恢复体力，未触发则无视对手免疫伤害效果；若对手不处于能力提升状态，则造成的伤害提升100%。",
        ]);
        this.技能组 = [
            skill.瞬念袭,
            skill.重击踩踏,
            skill.神力封印,
            skill.山神护体,
            skill.炫彩神力,
        ];
        this.皮肤组.push(new Skin(3590, "炫彩山神·迪符特"));
    }
}